import React from 'react';
import { useTranslation } from 'react-i18next';
import BookmarkIcon from '../Icons/BookmarkIcon';
import EyeIcon from '../Icons/EyeIcon';
import CommonMenu from './CommonMenu';
import { FiTrash2 } from 'react-icons/fi';

const PostcardOptionsMenu = ({ isOpen, onSelect, onClose, showDelete, customItems = [] }) => {
    const { t } = useTranslation();
    if (!isOpen) return null;

    const items = [
        {
            id: 'saveToCollection',
            label: t('UI.PostcardOptionsMenu.saveToCollection'),
            icon: <BookmarkIcon size={20} />,
            onClick: () => onSelect('saveToCollection'),
        },
        {
            id: 'viewPost',
            label: t('UI.PostcardOptionsMenu.viewPost'),
            icon: <EyeIcon size={20} />,
            onClick: () => onSelect('viewPost'),
        },
        // Добавляем кастомные элементы
        ...customItems
    ];
    
    if (showDelete) {
        items.push({
            id: 'deletePostcard',
            label: t('UI.PostcardOptionsMenu.delete'),
            icon: <FiTrash2 size={20} />, 
            className: 'text-red-500',
            onClick: () => onSelect('deletePostcard'),
        });
    }

    return (
        <CommonMenu onClose={onClose} items={items} />
    );
};

export default PostcardOptionsMenu; 